import {Component, Input, OnInit} from '@angular/core';
import {RuleModel} from "../../../../core/models/misc/rule.model";
import {ConstraintsDialogComponent} from "../../../../shared/components/constraints-dialog/constraints-dialog.component";
import {DialogService} from "../../../../service/services/misc/dialog/dialog.service";
import {ResourceModel} from "../../../../core/models/resources/resource.model";

@Component({
    selector: 'app-constraint-notification',
    templateUrl: './constraint-notification.component.html',
    styleUrls: ['./constraint-notification.component.scss'],
    standalone: false
})
export class ConstraintNotificationComponent implements OnInit{

  @Input() isEdit = false;
  @Input() isDelete = false;
  @Input() resource: any;
  @Input() type = 'create';


  rules: RuleModel[] = [];
  rule: RuleModel;
  hasConstraints = false;
  hasMultipleConstraints = false;


  constructor(private dialogService: DialogService) {
  }

  ngOnInit() {

      this.setRules(this.resource?.rules);
  }

  setRules(rules: []) {
      this.rules = rules;
      if (this.rules?.length > 0) {
          const rulesWithConstraints = this.rules
              .filter((r) => r.constraints)
              .filter((r) => Object.keys(r.constraints).length > 0);

          if (rulesWithConstraints.length == 1) {
              this.rule = rulesWithConstraints[0];
              this.hasConstraints = this.rules.some((r) => Object.keys(r.constraints).length > 0);
          } else if (rulesWithConstraints.length > 1) {
              this.hasMultipleConstraints = true;
          }
      }
  }

  onClickConstraints(event: Event, rule: RuleModel) {
      event.preventDefault();
      this.dialogService.openDialog(ConstraintsDialogComponent, {data: rule, source: this.type});
  }

}
